import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_5'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_5',
  name: 'Does the facility have any of the following safety measures in place related to firefighting equipment?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FIREFIGHTING_EQUIPMENT_IS_CLEARLY_MARKED_AND_EQUIPPED_WITH_INST',
      text: 'Firefighting equipment is clearly marked and equipped with instructions on how to operate',
      externalIds: [
        {
          id: 'hs-20--3-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CERTIFIED_FIRE_RESISTANT_DOORS_AND_FIRE_RESISTANT_WALLS_ARE_IN_',
      text: 'Certified fire-resistant doors and fire-resistant walls are in use in production units',
      externalIds: [
        {
          id: 'hs-20--3-9x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FIRE_FIGHTING_EQUIPMENT_IS_ACCESSIBLE',
      text: 'Fire Fighting equipment is accessible',
      externalIds: [
        {
          id: 'hs-eme-9',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-20--3-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FIREFIGHTING_EQUIPMENT_IS_CLEARLY_MARKED_AND_EQUIPPED_WITH_INST',
                'CERTIFIED_FIRE_RESISTANT_DOORS_AND_FIRE_RESISTANT_WALLS_ARE_IN_',
                'FIRE_FIGHTING_EQUIPMENT_IS_ACCESSIBLE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-eme-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14750,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
